import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools } from "zustand/middleware";

// US 874329: holds whether the current session's plant is a test/training
// environment (sy_registration.test_train_flag, surfaced by the server as
// IsTestEnvironment). Populated after the user session settings load and read
// by TestEnvBanner to show the Test/Training banner — mirrors the EAM web app.
type TestEnvironmentState = {
  isTestEnvironment: boolean;
};

type TestEnvironmentAction = {
  setIsTestEnvironment: (isTestEnvironment: boolean) => void;
};

const defaultState: TestEnvironmentState = {
  isTestEnvironment: false,
};

export const useTestEnvironmentStore = create<
  TestEnvironmentState & TestEnvironmentAction
>()(
  devtools(
    immer((set) => ({
      ...defaultState,
      setIsTestEnvironment(isTestEnvironment) {
        set((state) => {
          state.isTestEnvironment = isTestEnvironment;
        });
      },
    })),

    {
      name: "TestEnvironmentStore",
      enabled: true,
    }
  )
);
